import { groupBy } from "lodash";
import { uuidGenerator } from "../../../utils";

export const transformOrders = orders => {
  const trips = groupBy(orders, x => x.TripKey);
  const result = Object.keys(trips).map(x => {
    trips[x] = trips[x].sort((a, b) => {
      if (a.Leg > b.Leg) return 1;
      if (b.Leg > a.Leg) return -1;
      return 0;
    });
    return {
      id: uuidGenerator(),
      Trip: trips[x][0].Trip,
      PickupDate: trips[x][0].PickupDate,
      Leg: trips[x][0].Leg,
      PickupDriver: trips[x][0].PickupDriver,
      PickupDriverFirstName: trips[x][0].PickupDriverFirstName,
      PickupDriverLastName: trips[x][0].PickupDriverLastName,
      BookingCode: trips[x][0].BookingCode,
      PickupTractor: trips[x][0].PickupTractor,
      PickupTrailer: trips[x][0].PickupTrailer,
      Pickup_LocationId: trips[x][0].Pickup_LocationId,
      PickUp_LocationName: trips[x][0].PickUp_LocationName,
      PickUp_City: trips[x][0].PickUp_City,
      PickUp_State: trips[x][0].PickUp_State,
      Del_LocationId: trips[x][0].Del_LocationId,
      Del_LocationName: trips[x][0].Del_LocationName,
      Del_City: trips[x][0].Del_City,
      Del_State: trips[x][0].Del_State,
      Orders: trips[x],
      StatusId: trips[x][0].StatusId
    };
  });
  return result;
};
